import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import * as Yup from "yup";
import * as actions from "../../sc-core/Auth/store/authActions";
import LoginForm from "./LoginForm";
import appTranslations, { detectBrowserLanguageCode } from "../../sc-translate/appTranslations";
import { Tooltip, IconButton } from "@material-ui/core";
import { Chat, Help } from "@material-ui/icons";
import HubSpotChat from "../../sc-utilities/HubSpotChat";
import config from "../../../config/config";
import AuthenticatorAppModal from "../../sc-profile/YourSettings/AuthenticatorModal";
import OpenIDConnect from "../OpenIDConnect"
import * as profileActions from "../../sc-profile/store/profileActions";
const styles = theme => ({
    main: {
        width: "auto",
        display: "block", // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(6))]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    logo: {
        width: "250px",
        margin: "10px"
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing()
    },
    helpDeskStyle: {
        display: 'flex',
        flexDirection: 'row'
    }
});

const Login = props => {
    const { classes, onLogin, translations, onForgotPassword, socket, fetchVerifyOtp, loginSuccess } = props;
    const [value, setValue] = useState(false);
    const { openHandler, closeHandler, hasLoaded } = HubSpotChat(config.hubspot_id);

    const [show2fa, setShow2fa] = useState({ open: false });
    const [loginInfo, setLoginInfo] = useState(null);

    const handleClickShowPassword = () => {
        setValue(!value);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const handleSubmit = async data => {
        let loginData = {
            ...data,
            ClientType: "dashboard_client",
            ClientVersion: "2.8",
            SocketID: socket?.id?.split("#")[1] || null
        };
        const login = await onLogin(loginData);
        if (login) {
            setLoginInfo(login);            
            window.localStorage.setItem("CustomerTimezone", login.activeCustomer?.Timezone ?? '');
            if (!login.Authentications) {
                loginSuccess(login, true);
            } else if (login.AuthenticationEnabled) {
                setShow2fa({ open: true });
            }
        }
    };
    const handleLanguageChange = e => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        socket.emit("get-translations", { LanguageKey: e?.target?.value });
    };
    let initialValues = {
        Username: "",
        Password: "",
        language: detectBrowserLanguageCode() || 'en'
    };

    let formSettings = {
        Validation: {
            Username: Yup.string().required("Required"),
            Password: Yup.string().required("Required"),
        },
        ButtonSubmit: {
            Title: translations["login"] || "Login",
            Color: "primary"
        },
    };

    const handleChat = useCallback(() => {
        if (!hasLoaded) {
            openHandler();
        } else {
            closeHandler();
        }
    }, [closeHandler, hasLoaded, openHandler])

    useEffect(() => {
        const chatInit = window.localStorage.getItem("hs-chat");
        if (chatInit !== "init") {
            window.localStorage.setItem("hs-chat", "init")
            let _hsp = window._hsp = window._hsp || [];
            _hsp.push(['revokeCookieConsent']);
        }       
    }, []);

    const verifyOtp = async (OTP, Type) => {
        const result = await fetchVerifyOtp({ ActiveCustomerID: loginInfo.ActiveCustomerID, OTP, Token: loginInfo.Token, Type });
        if (result?.Valid) {
            setShow2fa({ open: false });
          loginSuccess(result.SessionData);
       
        }
    };

    return (
        <main className={classes.main}>
            <CssBaseline />
            <Paper className={classes.paper}>
                <img
                    alt="App logo"
                    className={classes.logo}
                    src={props.logoPath ? process.env.PUBLIC_URL + props.logoPath : process.env.PUBLIC_URL + "/assets/images/app-logo.svg"}
                />
                {show2fa.open ?
                    <AuthenticatorAppModal translations={translations} modal={show2fa} verifyOtp={verifyOtp} showQRCode={false} loginInfo={loginInfo} /> :
                    <>
                        <Typography component="h1" variant="h6">
                            {translations["login"] || "Login"}
                        </Typography>
                        <LoginForm
                            value={value}
                            handleClickShowPassword={handleClickShowPassword}
                            handleMouseDownPassword={handleMouseDownPassword}
                            onForgotPassword={onForgotPassword}
                            formSettings={formSettings}
                            initialValues={initialValues}
                            handleSubmit={handleSubmit}
                            translations={translations}
                            appTranslations={appTranslations}
                            handleLanguageChange={handleLanguageChange}
                        />
                    </>}

                <div className={classes.helpDeskStyle}>
                    <Tooltip title={translations["help_desk"] || "Help desk"}>
                        <IconButton target="_blank" href="https://support.securaze.com/" color="inherit">
                            <Help />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={translations["contact_live_chat"] || "Contact/Live Chat"}>
                        <span>
                            <IconButton color="inherit" onClick={handleChat} disabled={!config.hubspot_id}>
                                <Chat />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <OpenIDConnect></OpenIDConnect>

                </div>
            </Paper>
        </main>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogin: loginData => dispatch(actions.login(loginData)),
        loginSuccess: (data, reload) => dispatch(actions.loginSuccess(data, reload)),
        onForgotPassword: params => dispatch(actions.forgotPassword(params)),
        fetchVerifyOtp: params => dispatch(profileActions.fetchVerifyOtp(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login));
